import { AxiosResponse } from 'axios';

import { IChargingStationOperationsResponse } from 'models/http/charging-stations';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { serverAxios } from 'utils/http';

class ChargingStationsHttp {
  protected readonly route = 'chargingStations';

  public async getMany(abortController?: AbortController): Promise<IChargingStationOperationsResponse> {
    return serverAxios
      .get(`/${this.route}/operators`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Highest,
      })
      .then((response: AxiosResponse<IChargingStationOperationsResponse>) => response.data);
  }
}

export default ChargingStationsHttp;
